
<component
  :is="as"
  class="list-item"
  :class="{ clickable, alert, selectable, split, multi: numFields > 1 }"
  :style="{ '--num-fields': numFields }"
  v-bind="$attrs"
  v-on="$listeners"
>
  <div class="content">
    <div v-if="selectable" class="checkbox-wrapper">
      <icon-button
        :icon="selected ? 'check_box' : 'check_box_outline_blank'"
        :class="{ success: selected }"
        @click.stop.prevent="$emit('toggleSelected')"
      />
    </div>

    <slot name="image" />

    <slot name="info" />
  </div>

  <div class="fields">
    <card-stat-item
      v-for="(field, i) in fields"
      :key="i"
      :card="card"
      :stat="field"
    />

    <stat-item
      v-for="(customField, i) in customFields"
      :key="i + (fields && fields.length ? fields.length : 0)"
      :label="customField.label"
      :value="customField.value"
    />
  </div>
</component>
